/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "scan_planner";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface StructureColumnType {
}

export enum StructureColumnType_Enum {
  FOUR_COLUMNS = 0,
  TWO_COLUMNS_LEFT = 1,
  TWO_COLUMNS_RIGHT = 2,
  UNRECOGNIZED = -1,
}

export function structureColumnType_EnumFromJSON(object: any): StructureColumnType_Enum {
  switch (object) {
    case 0:
    case "FOUR_COLUMNS":
      return StructureColumnType_Enum.FOUR_COLUMNS;
    case 1:
    case "TWO_COLUMNS_LEFT":
      return StructureColumnType_Enum.TWO_COLUMNS_LEFT;
    case 2:
    case "TWO_COLUMNS_RIGHT":
      return StructureColumnType_Enum.TWO_COLUMNS_RIGHT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StructureColumnType_Enum.UNRECOGNIZED;
  }
}

export function structureColumnType_EnumToJSON(object: StructureColumnType_Enum): string {
  switch (object) {
    case StructureColumnType_Enum.FOUR_COLUMNS:
      return "FOUR_COLUMNS";
    case StructureColumnType_Enum.TWO_COLUMNS_LEFT:
      return "TWO_COLUMNS_LEFT";
    case StructureColumnType_Enum.TWO_COLUMNS_RIGHT:
      return "TWO_COLUMNS_RIGHT";
    case StructureColumnType_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseStructureColumnType(): StructureColumnType {
  return {};
}

export const StructureColumnType = {
  encode(_: StructureColumnType, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StructureColumnType {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStructureColumnType();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): StructureColumnType {
    return {};
  },

  toJSON(_: StructureColumnType): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<StructureColumnType>, I>>(base?: I): StructureColumnType {
    return StructureColumnType.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StructureColumnType>, I>>(_: I): StructureColumnType {
    const message = createBaseStructureColumnType();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
